import  { useEffect } from "react";
import browserUpdate from "browser-update";

const BrowserUpdate = () => {
  useEffect(() => {
    browserUpdate({
      required: { e: -2, f: -3, o: -3, s: -1, c: -3 }, // Required browser versions
      insecure: true,
      unsupported: true,
      text: "Your browser is outdated. Please update for a better experience.",
      reminder: 12,
      newwindow: true,
      onshow: (info) => {
        console.log("Browser update message shown", info);

        // Wait for the update box to appear in the DOM
        setTimeout(() => {
          const updateBox = document.querySelector(".buorg"); // class used by browser-update
          if (updateBox && !updateBox.querySelector(".buorg-close")) {
            // Create close button
            const closeBtn = document.createElement("button");
            closeBtn.textContent = "×";
            closeBtn.className =
              "buorg-close";
            closeBtn.style.cssText =
              "position:absolute;top:5px;right:10px;background:none;border:none;font-size:20px;cursor:pointer;";

            closeBtn.onclick = () => {
              updateBox.style.display = "none";
            };

            updateBox.appendChild(closeBtn);
          }
        }, 200); // Small delay to ensure the banner is rendered
      },
    });
  }, []);

  return null;
};

export default BrowserUpdate;
